import PropTypes from "prop-types";
import Card from "components/organisms/Card";
import "./styles.scss";

const Stories = ({ response, baseUrl }) => {
  return (
    <div className="stories" data-site-content>
      <Card card={response?.tasks?.cards?.[0]} baseUrl={baseUrl} />
    </div>
  );
};

Stories.propTypes = {
  response: PropTypes.shape({
    tasks: PropTypes.shape({
      cards: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          picture: PropTypes.string,
          story: PropTypes.string,
        })
      ),
    }),
  }),
  baseUrl: PropTypes.string,
};

export default Stories;
